<template>
  <div>
    <commBanner :obj="obj"></commBanner>
    <titleHead :headTitle="headTitle"></titleHead>
    <div class="w80 mb-30">
      <el-container>
        <el-aside width="330px">
          <sidebar></sidebar>
        </el-aside>
        <el-main>
          <contTitle :obj="obj" :contTitle="contTitle"></contTitle>
          <companySide class="mt-20" :isButton="isButton"></companySide>
          <div class="mt-30">
            <contTitle :obj="obj" :contTitle="contTitle2"></contTitle>
            <div class="info_form mt-20">
              <el-form
                ref="form"
                :rules="rules"
                :label-position="labelPosition"
                :model="form"
                label-width="130px"
              >
                <el-form-item label="标题 ：" prop="title" style="width: 100%">
                  <el-input
                    v-model="form.title"
                    placeholder="不超过50个字"
                    :maxlength="50"
                    clearable
                  ></el-input>
                </el-form-item>
                <div class="fdc">
                  <div style="width: 50%">
                    <el-form-item label="价格 ：" prop="price" style="width: 95%">
                      <el-input v-model="form.price" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="发货期限 : " prop="timeLimit" style="width: 95%">
                      <el-input v-model="form.timeLimit" clearable></el-input>
                      <!-- <el-date-picker type="date" placeholder="选择日期" v-model="form.timeLimit" clearable style="width: 100%;"></el-date-picker> -->
                    </el-form-item>
                    <el-form-item
                      label="供应类别 :"
                      prop="supplyType"
                      class="box_type"
                      style="width: 100%"
                    >
                      <el-radio-group v-model="form.supplyType">
                        <el-radio :label="0">产品</el-radio>
                        <el-radio :label="1">服务</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </div>
                  <div style="width: 50%">
                    <el-form-item label="发货地址 : " prop="address" style="width: 100%">
                      <el-input class="ml-80" v-model="form.address" clearable></el-input>
                    </el-form-item>
                    <el-form-item
                      label="联 系 人 ："
                      prop="concatName"
                      style="width: 100%"
                    >
                      <el-input v-model="form.concatName" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="联系电话 :" prop="telPhone" style="width: 100%">
                      <el-input v-model="form.telPhone" clearable></el-input>
                    </el-form-item>
                  </div>
                </div>
                <el-form-item
                  label="系统分类："
                  prop="categoryId"
                  class="box_region"
                  style="width: 100%"
                >
                  <el-select
                    v-model="form.fisrtId"
                    clearable
                    placeholder="系统分类："
                    style="width: 25%"
                    @change="changOne"
                  >
                    <el-option
                      v-for="(item, index) in systemList"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>

                  <el-select
                    v-model="form.twoId"
                    clearable
                    placeholder="系统分类："
                    style="width: 25%"
                    @change="((val)=>{
                      changeTwo(val),
                      $forceUpdate()
                    })">
                    <el-option
                      v-for="(item,index) in dataList"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>

                  <!--                  <el-select  v-if="isThree == true" clearable  v-model="form.changeTwo" placeholder="系统分类：" style="width:25%;">-->
                  <!--                    <el-option-->
                  <!--                      v-for="(item,index) in threeList"-->
                  <!--                      :key="index" :label="item.name"-->
                  <!--                      :value="item.name">-->
                  <!--                    </el-option>-->
                  <!--                  </el-select>-->
                </el-form-item>
                <el-form-item
                  class="custom"
                  label="自定义分类："
                  prop="custom"
                  style="width: 100%"
                >
                  <el-select
                    v-model="customId"
                    class="mr-20"
                    clearable
                    placeholder=""
                    style="width: 28%"
                    @change="changeCustom"
                  >
                    <el-option
                      v-for="(item, index) in customList"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                  <el-select
                    v-model="custom_id"
                    class="mr-20"
                    clearable
                    placeholder=""
                    style="width: 28%"
                    @change="changeFar"
                  >
                    <el-option
                      v-for="(item, index) in custList"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                  <el-button
                    class="mr-20"
                    icon="el-icon-plus"
                    @click.prevent="addSort()"
                    circle
                  ></el-button>
                  <p>编辑自定义分类</p>
                </el-form-item>
                <div class="picture mt-10">
                  <p>图片信息，最多可以上传5张图片，192*143px，1M以内</p>
                  <div class="pictures">
                    <el-upload
                      :headers="{ token: token }"
                      action="/api/zwb/app/oss/public/upload"
                      list-type="picture-card"
                      :limit="5"
                      :on-success="onSuccess"
                      :before-upload="handlePictureCardPreview"
                      :on-remove="handleRemove"
                      :file-list="fileList"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                      <img width="100%" :src="dialogImageUrl" alt="" />
                    </el-dialog>
                  </div>
                  <div class="wire mt-20"></div>
                  <div class="mt-20">
                    <p class="text_center">参数信息</p>
                    <div class="mt-10">
                      <div class="new" v-for="(item, index) in paraForm" :key="index">
                        <div style="width: 40%">
                          <el-form-item label="产品属性名称  " prop="attributes"  style="width: 90%">
                            <el-input v-model="item.attributes" clearable></el-input>
                          </el-form-item>
                        </div>
                        <div style="width: 60%" class="fdc">
                          <el-form-item label="产品属性值 : " prop="propertyValue" style="width: 80%">
                            <el-input v-model="item.propertyValue" clearable></el-input>
                          </el-form-item>
                          <el-button
                            class="new_add"
                            @click.prevent="addParameter()"
                            icon="el-icon-plus"
                            circle
                          ></el-button>
                          <el-button
                            class="new_reduce"
                            icon="el-icon-minus"
                            @click.prevent="removeParameter(item)"
                            circle
                          ></el-button>
                        </div>
                      </div>
                    </div>
                    <div class="wire"></div>
                  </div>
                  <div class="mt-10 tel">
                    <el-form-item label="详情介绍"  >
                      <tinymceEditor
                      class="mt-20"
                      v-model="form.content"
                      ref="editor"
                    ></tinymceEditor>
                    </el-form-item>
                    <el-form-item label="SEO关键词 ：" style="width: 100%">
                      <el-input
                        v-model="form.seokeywords"
                        placeholder="多个关键词使用英文逗号分隔"
                        clearable
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="SEO描述 ：" style="width: 100%">
                      <el-input
                        v-model="form.seodescription"
                        type="textarea"
                        clearable
                      ></el-input>
                    </el-form-item>
                    <el-form-item   prop="agree" class="fuck">
                      <el-checkbox v-model="form.agree" name="checked"></el-checkbox>
                      <div style="margin-left: 5px">
                        我已阅读并同意《
                        <span class="agree" @click="settChange()">供需信息发布声明</span>
                        》
                      </div>
                    </el-form-item>
                    <!-- <p class="text_center">详情介绍</p> -->
                    <el-button class="save_btn " @click="onSubmit('form')"
                      >保存</el-button
                    >
                  </div>
                </div>
              </el-form>
            </div>

            <!--弹框-->
            <el-dialog
              class="dialog_form"
              title="编辑自定义分类"
              :visible.sync="dialogFormVisible"
            >
              <el-form :model="dialogForm" ref="dialogForm" :rules="rulesForm">
                <el-form-item label="自定义分类:" :label-width="formLabelWidth">
                  <el-tree
                    :data="treeData"
                    show-checkbox
                    node-key="id"
                    ref="tree"
                    default-expand-all
                    :props="defaultProps"
                    @check-change="handleClickChange"
                  >
				  <span class="custom-tree-node" slot-scope="{ node, data }">
					 <span>{{ node.label }}</span>
					 <span>
						 <el-button  type="text" size="mini" @click="() => remove(node, data)">删除</el-button>
					 </span>
				  </span>
                  </el-tree>
                </el-form-item>
                <el-form-item
                  label="分类名称:"
                  prop="classifyName"
                  :label-width="formLabelWidth"
                  style="width: 90%"
                >
                  <el-input
                    v-model="dialogForm.classifyName"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <button class="foot_btn" @click="submitClass('dialogForm')">
                  添加分类
                </button>
              </div>
            </el-dialog>

            <!--发布声明弹框-->
            <div class="sett_dialog" v-show="dialogTableVisible">
                <div class="sett_cox"></div>
                <div class="sett_dialog_box">
                  <div class="sett_matter">
                    <p class="sett_title">供需信息发布声明</p>
                    <p class="sett_jitr">
                      <span v-if="!isImg">{{ time }}s</span>
                      <img
                        v-show="isImg"
                        src="../../assets/images/sign.png"
                        @click.prevent="onText()"
                      />
                    </p>
                  </div>
                  <div class="sett_desc" v-html="issueStatement.des"></div>
                </div>
            </div>
            
          </div>
        </el-main>
      </el-container>
    </div>
  </div>
</template>
<script>
import {
  addSupply,
  systemList,
  selSupplyType,
  addSupplyType,
  editSupply,
  suppType,
  getSupply,
  delsuppType
} from "@/api/company";
import {agreement} from '@/api/coment'
import { getToken } from "@/utils/auth";
import sidebar from "../../common/sidebar";
import companySide from "../../common/companySide";
import commBanner from "../../common/commBanner";
import titleHead from "../../common/titleHead";
import contTitle from "../../common/contTitle";
import paletteBar from "../../common/paletteBar";
import tinymceEditor from "../../common/tinymceEditor.vue";
export default {
  components: {
    sidebar,
    companySide,
    commBanner,
    titleHead,
    contTitle,
    paletteBar,
    tinymceEditor,
  },
  data() {
    //验证手机号规则
    var checkMobile = (rule, value, cb) => {
      // 验证手机号的正则表达式
      // const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
      const regMobile = /^((0\d{2,3}))(\d{7,8})$/;
      const regMobiles = /^1[0-9]{10}$/;
      if (regMobile.test(value) || regMobiles.test(value)) {
        return cb();
      }
      cb(new Error("请输入合法的手机号"));
    };
    return {
      msg: "",
      headTitle: "企业供应",
      contTitle: "企业基本信息",
      contTitle2: "添加供应",
      obj: {
        title: "供应信息",
        isShow: false,
        isColor: false,
        roleType: 3,
        personalType: 9,
      },
      paletteObj: {
        paletteTitle: "企业供应",
        paletteCount: 10,
        paletteName: "添加供应",
        paletteText: "删除供应",
        isShow: true,
        isDelete: true,
        isView: true,
      },
      fisrtId: "", //一级id
      twoId: "", //二级Id
      customId: "", //自定义一级id
      custom_id: "", //自定义二级id
      form: {
        title: "",
        price: "",
        categoryId: "", //类别
        timeLimit: "", //期限
        address: "",
        cover: "", //封面
        telPhone: "", //联系电话
        concatName: "", //联系人
        images: "", //商品图片
        supplyType:null, //供应类别
        customizeTypeId: "", //自定义分类id,
        content: "", //详情介绍
        attr: "", //产品属性名和产品属性值
        userId: "",
        agree:'',
        seokeywords:'',   //关键词
        seodescription: '', //描述
      },
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        price: [{ required: true, message: "请输入价格", trigger: "blur" }],
        timeLimit: [{ required: true, message: "请输入发货期限", trigger: "blur" }],
        address: [{ required: true, message: "请输入发货地址", trigger: "blur" }],
        telPhone: [
          { required: true, message: "请输入联系人电话", trigger: "blur" },
          // { validator: checkMobile, message: "请输入正确的手机号码", trigger: "blur" },
        ],
        concatName: [{ required: true, message: "请输入联系人", trigger: "blur" }],
        supplyType: [{ required: true, message: "请选择供应类别", trigger: "change" }],
        agree: [{ required: true, message: "请接受智污邦发布声明",trigger: "change"}],
        // seokeywords: [{ required: true, message: "SEO关键词不能为空",trigger: "change"}],
        // seodescription: [{ required: true, message: "SEO描述不能为空",trigger: "change"}],
        // categoryId: [{ required: true, message: "请选择系统分类", trigger: "change" }],
        //custom:[{ required: true, message: '请选择自定义分类', trigger: 'change' }],
        // attributes:[{ required: true, message: '请输入产品属性名称', trigger: 'blur' }],
        // propertyValue:[{ required: true, message: '请输入产品属性值', trigger: 'blur' }],
      },
      paraForm: [],
      dialogImageUrl: "",
      dialogVisible: false,
      labelPosition: "left",
      dialogFormVisible: false,
      formLabelWidth: "120px",
      isThree: true,
      dialogForm: {
        classifyName: "",
      },
      rulesForm: {
        classifyName: [{ required: true, message: "请输入分类名称", trigger: "blur" }],
      },
      treeData: [],
      defaultProps: {
        children: "children",
        label: "name"
      },
      systemList: [], //一级
      dataList: [], //二级
      threeList: [], //三级
      attList: [],
      imageList: [], //图片数组
      fileList:[],
      customList: [], //自定义一级
      custList: [],
      treeObj: {},
      token: getToken(),
      isButton: false,
      checkList: [],
      dialogTableVisible: false,
      isImg: false,
      time: 10,
      issueStatement: "",
      supplyId:''
    };
  },
  created() {
    this.getSystem();
    this.getSupplyType();
    this.getAgreement();
    let compyInfo = this.$store.state.user.userInfo.data;
    this.form.concatName = compyInfo.contact || compyInfo.realname;
    this.supplyId = this.$route.query.id;
    if(this.supplyId){
      this.getSupplyInfo(this.supplyId);
    }else{
      this.form.telPhone = compyInfo.telphone;
      this.paraForm =[{attributes: "", propertyValue: ""}]//初始化添加一条
    }
  },
  computed: {
    industryList() {
      return this.$store.getters.industry;
    },
  },
  watch: {
    industryList: {
      handler(val) {},
      immediate: true,
    },
  },
  methods: {
    getSupplyInfo(id){
      let parmas ={id:id};
      getSupply(parmas).then((res)=>{
        if(res.code == 0){
            this.form = res.data;
           //处理图片
            let list = res.data.images.split(',');
            list.forEach((item)=>{
             let obj = {url:item};
             this.fileList.push(obj);
            });
           //处理参数信息
            let attr = res.data.attr.split(',');
            let atts = [];
            let bb = attr.forEach((items)=>{
              let obj = {
                attributes:items.split(':')[0],
                propertyValue:items.split(':')[1]
              };   
               atts.push(obj);
            });
            this.paraForm = atts;
            
            let arr = this.getParentIds(this.systemList,res.data.categoryId);
            let results = Number(arr);
            // let result = this.findParent(this.systemList,res.data.categoryId);
            this.form.fisrtId = results;
            this.systemList.forEach((info)=>{
              if(info.id == results){
                 this.dataList = info.children;
              }
            });
           this.form.twoId = res.data.categoryId;
        }
      }).catch((err)=>{})
    },

    onSuccess(res) {
      if (res.code == 0) {
        this.imageList.push(res.url);
        this.form.cover = this.imageList[0];
        this.form.images = this.form.images ? this.form.images + "," + res.url : res.url;
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      //上传前对图片类型和大小进行判断
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg";
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG,PNG 格式!");
      }
      if (!isLt1M) {
        this.$message.error("上传头像图片大小不能超过 1MB!");
      }
      // if (!isLt1M) {
      //   this.$message.error("上传头像图片大小不能超过 1MB!");
      // }else{
      //     const isSize = new Promise((resolve, reject) => {
      //         const width = 192;
      //         const height = 143;
      //         const _URL = window.URL || window.webkitURL;
      //         const img = new Image();
      //         img.onload = () => {
      //             const valid = img.width >= width && img.height >= height && img.width === img.height;
      //             valid ? resolve() : reject();
      //         };
      //         img.src = _URL.createObjectURL(file);
      //     }).then(
      //         () => {
      //             return file;
      //         },
      //         () => {
      //             this.$message.error('图片尺寸限制最小为192 x 143，大小不可超过1MB');
      //             return Promise.reject();
      //         },
      //     );
      //     return isSize;
      // }

      return isJPG && isLt1M;
    },
    handleRemove(file, fileList) {
      let orr = [];
      fileList.forEach((item)=>{
        orr.push(item.url)   
      });
      let str = orr.join(',')
      this.form.images = str;
    },

    //自定义分类
    addSort() {
      this.dialogFormVisible = true;
      this.getSuppTypeId();
    },
    //选择一级分类
    changOne(row) {
      this.systemList.forEach((item) => {
        if (item.id == row) {
          this.dataList = item.children;
        }
      });
    },
    //选择二级分类
    changeTwo(row) { 
      this.form.categoryId = row;
      // this.dataList.forEach((item) => {
      //   this.form.categoryId = item.id;
      //   // if (item.id != row) {
      //   //   this.isThree = false;
      //   //   this.form.categoryId = item.id;
      //   //   console.log(item)
      //   // } else {
      //   //   this.threeList = item.children;
      //   // }
      // });
    },
    //保存
    onSubmit(formName) {
      this.paraForm.forEach((item) => {
        let att = item["attributes"];
        let atts = item["propertyValue"];
        let str = att + ":" + atts;
        this.attList.push(str);     
     });
     this.form.attr = this.attList.join(',');
     this.$refs[formName].validate((valid) => {
        if (valid) {
          this.form.userId = this.$store.state.user.userInfo.data.userId;  
          if(this.supplyId){  //编辑
            editSupply(this.form).then((res)=>{
              if(res.code == 0 ){
                this.$message({
                  message: "提交成功！",
                  type: "success",
                  duration: 1000,
                  onClose: () => {
                    this.$router.push("/corporate_supply");
                  },
                });
              }
            }).catch((err)=>{})
          }else{ // 添加
            addSupply(this.form).then((res) => {
              if (res.code == 0) {
                this.$message({
                  message: res.msg,
                  type: "success",
                  duration: 1000,
                  onClose: () => {
                    this.$router.push("/corporate_supply");
                  },
                });
              }
            }).catch((err) => {});
          }
        } else {
          return false;
        }
      });
    },

    //自定义一级
    changeCustom(row) {
      this.customList.forEach((item) => {
        if (item.id != row) {
          this.form.customizeTypeId = row;
          return false;
        } else {
          this.custList = item.children;
        }
      });
    },
    changeFar(row) {
      this.form.customizeTypeId = row;
    },
    //增加参数
    addParameter() {
      this.paraForm.push({ attributes: "", propertyValue: "" });
    },
    //删除参数
    removeParameter(item) {
      var index = this.paraForm.indexOf(item);
      if (index == 0) {
        return false;
      } else if (index !== -1) {
        this.paraForm.splice(index, 1);
      }
    },
    //系统分类
    getSystem() {
      let params = {};
      systemList(params)
        .then((res) => {
          this.systemList = res.data;
        })
        .catch((err) => {});
    },
    //查询自定义分类
    getSupplyType() {
      let params = {};
      selSupplyType(params)
        .then((res) => {
          if (res.code == 0) {
            this.customList = res.data;
          }
        })
        .catch((err) => {});
    },
    //查询user_id
    getSuppTypeId() {
      let params = {
        user_id: this.$store.state.user.userInfo.data.userId,
      };
      suppType(params)
        .then((res) => {
          if (res.code == 0) {
            this.treeData = res.data;
          }
        })
        .catch((err) => {});
    },
    //添加自定义分类
    submitClass(formName) {
      this.dialogFormVisible = false;
      let postData = {
        id: '',
        name: this.dialogForm.classifyName,
        pid: this.treeObj.id == undefined ? 0: this.treeObj.id,
        level:'',
        userId:'',
        sort: 0,
		children:[]
      };
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addSupplyType(postData)
            .then((res) => {
              if (res.code == 0) {
                this.$message({
                  message: "添加成功！",
                  type: "success",
                  duration: 1000,
                });
				this.dialogForm.classifyName = "";
                this.getSupplyType();
              }
            })
            .catch((err) => {});
        } else {
          return false;
        }
      });
    },
    //tree 节点点击时回调
    handleClickChange(event) {
      this.treeObj = event;
    },
	//删除节点
	remove(node, data){
		var params = {id:data.id};
		this.$confirm('确定要删除吗','提示',{
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(()=>{
		  delsuppType(params).then((res)=>{
			 if(res.code == 0){
			 this.$message({
			   message:'删除成功！',
			   type: 'success',
			   duration:1000,
			   onClose:()=>{
				  this.getSuppTypeId();
				  this.getSupplyType();
				}
			 });
			 }
		  }).catch((err)=>{})
		}).catch(()=>{})
    },
    //查询发布声明
    getAgreement() {
      agreement()
        .then((res) => {
          this.issueStatement = res.page.filter((item) => item.name == "供需信息发布声明")[0];
        }).catch((err) => {});
    },
    settChange() {
      this.dialogTableVisible = true;
      this.timer = setInterval(() => {
        this.time--;
        if (this.time == 0) {
          clearInterval(this.timer);
          this.isImg = true;
        }
      }, 1000);
    },
    onText() {
      this.dialogTableVisible = false;
    },
    findParent(tree, id){
      for(var i =0;i<tree.length;i++){       
        if(tree[i].id == id){          
          return tree[i].pid;
        }else if(tree[i].children != null && tree[i].children.length>0){  
          let atr = this.findParent(tree[i].children,id)    
          if(atr != null) {
            return atr;
          }
        }      
      }
      return null;
    },
    //根据id 查询父级内容
    getParentIds(data,id){
      let pant = (data,id,parents)=>{
        for(var i = 0;i<data.length;i++){
           var item = data[i];
          // 找到id则返回父级id
          if(item.id === id) return parents;
          // children不存在或为空则不递归
          if(!item.children || !item.children.length) continue;
          // 往下查找时将当前id入栈
          parents.push(item.id);
          
          if(pant(item.children, id, parents).length ) return parents;
          // 深度遍历查找未找到时当前id 出栈
          parents.pop()
        } 
         // 未找到时返回空数组
        return [];
      }
       return pant(data, id, []);
    }

  },
};
</script>
<style scoped>
.el-aside {
  height: 100%;
}
.mt-20 {
  margin-top: 20px;
}
.mr-20 {
  margin-right: 20px;
}
.el-pagination {
  margin-top: 40px;
}

.info_form >>> .el-form-item__label {
  color: #333333;
  font-size: 14px;
}
.info_form >>> .el-radio__inner:hover {
  background: none;
}
.info_form >>> .el-radio__input.is-checked .el-radio__inner {
  border-color: #50b035;
  background: #50b035;
}
.info_form >>> .el-radio__input.is-checked + .el-radio__label {
  color: #333333;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #3bae30 !important;
  color: #fff;
}
.info_form >>> .el-button:focus,
.el-button:hover {
  /* background-color: #FFFFFF !important; */
  border-color: #dcdfe6 !important;
  color: #dcdfe6 !important;
}
.info_form >>> .el-input__inner {
  height: 50px;
}
.info_form >>> .el-button.is-circle {
  height: 40px;
}
.info_form >>> .el-button:hover {
  cursor: pointer;
}
.box_attributes >>> .el-form-item__label {
  text-align: left;
}

.box_region >>> .el-form-item__content {
  margin-left: 0px !important;
  text-align: left;
}
.box_type >>> .el-form-item__content {
  margin-left: 0px !important;
  text-align: left;
}
.custom >>> .el-form-item__content {
  margin-left: 0px !important;
  display: flex;
  justify-content: flex-start;
  align-content: center;
}
.custom p {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
}
.picture {
  text-align: left;
  width: 100%;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
}
.picture p {
  font-size: 14px;
}
.pictures {
  margin-top: 20px;
}
.wire {
  width: 100%;
  border-bottom: 1px solid #eeeeee;
}
.keep {
  width: 114px;
  background: #3cbc36;
  border-radius: 3px;
}
.new {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.new_add {
  margin-top: -20px;
  margin-left: 20px;
}
.new_reduce {
  margin-top: -20px;
}
.text_center {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.save_btn {
  width: 114px;
  height: 35px;
  line-height: 10px;
  background: #3cbb36;
  border-radius: 3px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  border: none;
}
.tel>>>.el-button--default:hover{
   background: #3cbb36 !important;
}
.tel>>>.el-button:focus .el-button:hover{
  background: #3cbb36 !important;
  color: #ffffff !important;
}
.save_btn:hover {
  color: #ffffff !important; 
}
/**修改tree树 */
.dialog_form >>> .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #50b035 !important;
  border-color: #50b035 !important;
}
.dialog_form >>> .el-tree-node .is-expanded .is-focusable {
  border-color: #50b035;
}
.dialog_form >>> .el-tree-node__content:hover {
  border-color: #ffffff;
}
.dialog-footer {
  text-align: left;
}
.foot_btn {
  margin-left: 41px;
  margin-bottom: 10px;
  width: 114px;
  height: 35px;
  line-height: 10px;
  background: #3cbb36;
  border-radius: 3px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}


/**发布弹框样式 */
.sett_dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  margin: 0;
  z-index: 999;
}
.sett_dialog_box {
  width: 500px;
  height: 600px;
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 3px;
  transform: translate(-50%, -50%);
  background: #ffffff;
  overflow: auto;
}
.sett_cox {
  position: fixed;
  left: 0;
  /* opacity: 0.3; */
  width: 100%;
  height: 100%;
  top: 0;
  background-color: rgba(0, 0, 0, 0.8);
  /* z-index:2003 !important; */
}
.sett_matter {
  position: relative;
  height: 50px;
}
.sett_title {
  font-size: 22px;
  color: #666666;
  height: 30px;
  line-height: 48px;
  text-align: center;
}
.sett_jitr {
  position: absolute;
  right: 20px;
  top: 10px;
}
.sett_jitr img {
  width: 20px;
  height: 20px;
}
.sett_desc {
  padding: 30px;
  font-size: 14px;
  line-height: 24px;
  color: #666666;
}
/deep/ .fuck .el-form-item__content {
  display: flex;
  align-items: center;
}
.agree {
  cursor: pointer;
  color: #69cc1e;
}
.agree:hover {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/view/company/corporate_supplyAdd.vue